(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    ;(function () {
    const searchOpenToggle = document.getElementById('search-open')
    const searchInput = searchOpenToggle?.closest('search')?.querySelector(
      '.header-search-input',
    )
    const loadingEl = document.querySelector('.header-search-loading')
    const noResultsEl = document.querySelector('.header-search-no-results')
    const resultsList = document.querySelector('.header-search-list')
    const seeAllLink = document.querySelector('.header-search-see-all')
    const clearButton = document.querySelector('#search-clear')

    let debounceTimer

    function debounce(fn, delay) {
      clearTimeout(debounceTimer)
      debounceTimer = setTimeout(fn, delay)
    }

    function showLoading() {
      loadingEl.classList.remove('hidden')
      noResultsEl.classList.add('hidden')
      resultsList.innerHTML = ''
    }

    function hideLoading() {
      loadingEl.classList.add('hidden')
    }

    function showNoResults() {
      noResultsEl.classList.remove('hidden')
    }

    function clearResults() {
      resultsList.innerHTML = ''
      noResultsEl.classList.add('hidden')
      loadingEl.classList.add('hidden')
      seeAllLink.classList.add('hidden')
      clearButton.setAttribute('hidden', true)
    }

    function renderResults(resources, query) {
      resultsList.innerHTML = ''

      const products = resources.results?.products || []
      const articles = resources.results?.articles || []
      const pages = resources.results?.pages || []

      const allResults = [...products, ...articles, ...pages]
      const totalCount =
        (resources.results?.products_count || 0) +
        (resources.results?.articles_count || 0) +
        (resources.results?.pages_count || 0)

      if (allResults.length === 0) {
        showNoResults()
        seeAllLink.classList.add('hidden')
        return
      }

      seeAllLink.href = `/search?q=${encodeURIComponent(query)}`
      seeAllLink.classList.remove('hidden')

      allResults.forEach((item) => {
        const li = document.createElement('li')
        li.className = 'px-4'

        const link = document.createElement('a')
        link.href = item.url
        link.className = 'relative flex items-center gap-3 hover:before:absolute hover:before:-inset-2 hover:before:bg-vh-navy/10 hover:before:-z-1 hover:before:rounded'

        if (item.featured_image?.url || item.image) {
          const img = document.createElement('img')
          img.src = (item.featured_image?.url || item.image) + '&width=160'
          img.alt = item.title
          img.className = 'size-[80px] shrink-0 aspect-square object-cover rounded overflow-clip text-transparent'
          link.appendChild(img)
        }

        const textContainer = document.createElement('div')
        textContainer.className = 'flex flex-col'

        const title = document.createElement('span')
        title.className = 'text-sm font-light text-vh-navy'
        title.textContent = item.title
        textContainer.appendChild(title)

        if (item.price) {
          const price = document.createElement('span')
          price.className = 'text-xs text-vh-navy/50'
          const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
          })
          price.textContent = formatter.format(item.price)
          textContainer.appendChild(price)
        }

        link.appendChild(textContainer)
        li.appendChild(link)
        resultsList.appendChild(li)
      })
    }

    async function performSearch(query) {
      showLoading()

      try {
        const response = await fetch(
          `/search/suggest.json?q=${encodeURIComponent(
            query,
          )}&resources[type]=product,article,page&resources[limit]=5`,
        )
        const data = await response.json()
        hideLoading()
        renderResults(data.resources, query)
      } catch (error) {
        hideLoading()
        console.error('Search failed:', error)
      }
    }

    searchInput.addEventListener('input', (e) => {
      const query = e.target.value.trim()

      if (query.length < 2) {
        clearResults()
        return
      }

      clearButton.removeAttribute('hidden')
      debounce(() => performSearch(query), 1000)
    })

    clearButton.addEventListener('click', () => {
      searchInput.value = ''
      clearResults()
    })

    searchOpenToggle?.addEventListener('change', () => {
      if (searchOpenToggle.checked) {
        searchInput?.focus()
      }
    })
  })()
  } catch(e) { console.error(e); }
})();

})();
